<template>
<!-- 普通账单 -->
  <div class="ordinaryBill">
    <div class="y-pl-20 y-pt-20 y-pr-20 clearfix">
      <el-form ref="searchForm" :inline="true" :model="form">
        <el-form-item prop="createTime" label="账单生成时间">
          <yto-date-picker
            size="mini"
            :clearable="false"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            v-model="form.createTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </yto-date-picker>
        </el-form-item>
        <el-form-item prop="customerCode" label="客户编码">
          <el-select class="y-w-200" size="mini" v-model="form.customerCode" placeholder="请选择">
            <el-option v-for="item in kCodeOpts" :key="item.code" :label="item.code +'--'+ item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="billingStatus" label="对账状态">
          <el-select class="y-w-200" size="mini" v-model="form.billingStatus" placeholder="请选择">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待确认" value="0"></el-option>
            <el-option label="已确认" value="1"></el-option>
            <el-option label="已申诉" value="2"></el-option>
            <el-option label="申诉驳回" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="y-f-r">
          <div class="button-group">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
            <el-button size="mini" plain @click="resetForm('searchForm')">重置</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="y-h-10 y-bk-F0F2F8"></div>
    <div class="y-pd-20">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="汇总" name="summary">
          <el-button
            class="y-mb-10"
            type="primary"
            size="mini"
            :disabled="total==0"
            @click="handleExport">
            导出
          </el-button>
          <span class="y-fs-12 y-ml-10">
            <i class="el-icon-warning y-fc-4C84FF y-fs-14"></i>
            账单由合作网点推送后才可查询，可点击账单编号查看账单明细或进行对账申诉，账单无异议的请及时确认账单
          </span>
          <el-button size="mini" type="primary" icon="el-icon-s-tools" @click='tableConfig'>自定义列</el-button>
          <el-button style="float:right;" size="mini" type="primary" @click="autoVerifyBill('summary')">自动对账</el-button>
          <el-table key="summary" v-if="activeName=='summary' && showTable" ref="multipleTable" :data="summaryData" style="width: 100%" v-loading="loading"
            @selection-change="handleSelectionChange" :default-sort="{ prop: 'createTime', order: 'descending' }" @sort-change="sortChange">
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="scope">
                <!-- 网点管家对账状态：0未核对，1已确认，2已申诉未核对，3已驳回 -->
                <!-- 客户管家对账状态：0待确认，1已确认，2已申诉，3申诉驳回 -->
                <el-button :disabled="!(scope.row.billingStatus=='0'||scope.row.billingStatus=='3')" type="primary" size="mini" @click="confirmBill(scope.row)">确认账单</el-button>
              </template>
            </el-table-column>
            <template v-for="(item,index) in tableConfigHeadList">
              <el-table-column min-width="100px" :key="item.enName+index" :prop="item.enName" :label="item.cnName" align="center" v-if="item.enName=='billingNo'">
                  <!-- 账单编码 -->
                <template slot="header">
                  <check-down :title="item.cnName" :checkBoxList="allbillList" :defaultCheckBoxList="billingNoLst" @checked="checkedOrder"></check-down>
                </template>
                <template slot-scope="scope">
                    <span @click="handleClick(scope.row)" class="y-fc-4C84FF y-c-p">{{ scope.row.billingNo }}</span>
                </template>
              </el-table-column>
              <el-table-column :min-width="(item.cnName && item.cnName.length>4)?'120px':'100px'" :key="item.enName+index" :prop="item.enName" :label="item.cnName" align="center" :sortable="tableSortList.includes(item.enName)" v-else>
                <!-- 非账单编码 -->
                <template slot-scope="scope">
                  <template v-if="item.cnName=='申诉明细'">
                    <!-- 申诉明细 -->
                    <!-- 网点管家对账状态：0未核对，1已确认，2已申诉未核对，3已驳回 -->
                    <!-- 客户管家对账状态：0待确认，1已确认，2已申诉，3申诉驳回 -->
                    <span class="y-fc-4C84FF y-c-p" v-if="scope.row.billingStatus=='2'||scope.row.billingStatus=='3'" @click="complaintDetails(scope.row)">查看</span>
                  </template>
                  <template v-else-if="item.enName=='startTime' || item.enName=='endTime' || item.enName=='createTime'">
                    <!-- 账单开始时间\账单结束时间\账单生成时间 -->
                    <span>{{ scope.row[item.enName] | dateFilter }}</span>
                  </template>
                  <template v-else>
                    <span>{{ scope.row[item.enName] }}</span>
                  </template>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <div class="y-mt-20">
            <el-pagination
              class="y-t-ac"
              @size-change="limitChange"
              @current-change="pageChange"
              :current-page.sync="pageNo"
              :page-sizes="[10, 20, 50]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="明细" name="detail">
          <el-form :inline="true">
            <el-form-item label="运单号">
              <el-input placeholder="输入运单号查询" v-model="inputWaybillNo" size="mini" class="y-w-180" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="handleSearchWay">查询</el-button>
              <el-button size="mini" class="normal-btn" @click="exportDetailData" :disabled="detailTotal==0">导出</el-button>
              <el-button size="mini" type="primary" icon="el-icon-s-tools" @click='tableConfig'>自定义列</el-button>
            </el-form-item>
             <el-form-item style="float:right;">
              <el-button size="mini" type="primary" @click="autoVerifyBill" v-if="detailData && detailData.length && curRow && curRow.billingStatus!='1'">自动对账</el-button>
            </el-form-item>
          </el-form>
          <el-table key="detail" v-if="activeName=='detail' && showTable" :data="detailData" style="width: 100%" v-loading="loading"
            :default-sort="{ prop: 'createTime', order: 'descending' }" @sort-change="sortChangeByDetail" show-summary :summary-method="getSummaries">
            <template v-for="(item,index) in tableConfigHeadList">
              <el-table-column min-width="100px" :key="item.enName+index" :prop="item.enName" :label="item.cnName" align="center" v-if="item.enName=='provinceName'">
                <!-- 计费省份 -->
                <template slot="header">
                  <check-down :title="item.cnName" :checkBoxList="allProvinceList" :defaultCheckBoxList="provinceLst" @checked="checkedProvince"></check-down>
                </template>
                <template slot-scope="scope">
                    <span>{{ scope.row[item.enName] }}</span>
                </template>
              </el-table-column>
              <el-table-column :min-width="(item.cnName && item.cnName.length>4)?'120px':'100px'" :key="item.enName+index" :prop="item.enName" :label="item.cnName" align="center" :sortable="tableSortListByDetail.includes(item.enName)" v-else>
                <template slot-scope="scope">
                  <template v-if="item.enName=='createTime'">
                    <!-- 扫描时间 -->
                    <span>{{ scope.row[item.enName] | dateFilter }}</span>
                  </template>
                  <template v-else>
                    <span>{{ scope.row[item.enName] }}</span>
                  </template>
                </template>
              </el-table-column>
            </template>
            <el-table-column min-width="100px" prop="ioTypeName" label="重量取值来源" align="center" v-if="tableHeaderList.includes('ioTypeName')"></el-table-column>
            <el-table-column label="计费时间" align="center" v-if="tableHeaderList.includes('billingTime')">
              <template slot-scope="scope">
                {{ scope.row.billingTime | dateFilter }}
              </template>
            </el-table-column>
            <el-table-column prop="transFee" label="运费" align="center" v-if="tableHeaderList.includes('transFee')"></el-table-column>
            <el-table-column prop="addAmount" label="加收费" align="center" v-if="tableHeaderList.includes('addAmount')"></el-table-column>
            <el-table-column prop="extend7" label="面单费" align="center" v-if="tableHeaderList.includes('extend7')"></el-table-column>
            <el-table-column prop="optFee" label="操作费" align="center" v-if="tableHeaderList.includes('optFee')"></el-table-column>
            <el-table-column min-width="100px" prop="aidDeliveryFee" label="扶持派送费" align="center" v-if="tableHeaderList.includes('aidDeliveryFee')"></el-table-column>
            <el-table-column prop="extraFee" label="附加费" align="center" v-if="tableHeaderList.includes('extraFee')"></el-table-column>
            <el-table-column prop="optWeightFee" label="计重费" align="center" v-if="tableHeaderList.includes('optWeightFee')"></el-table-column>
            <el-table-column prop="overweightFee" label="超重派送费" align="center" v-if="tableHeaderList.includes('overweightFee')"></el-table-column>
            <el-table-column prop="hqFee" label="总部成本" align="center" v-if="tableHeaderList.includes('hqFee')"></el-table-column>
            <el-table-column prop="yqAddAmount" label="附加费出港" align="center" v-if="tableHeaderList.includes('yqAddAmount')"></el-table-column>
            <el-table-column prop="ultFeeAmt" label="超区件" align="center" v-if="tableHeaderList.includes('ultFeeAmt')"></el-table-column>
            <el-table-column min-width="100px" prop="backReverseAmt" label="退回逆向费用" align="center" v-if="tableHeaderList.includes('backReverseAmt')"></el-table-column>
            <el-table-column min-width="100px" prop="bsBackAmt" label="退回件服务费" align="center" v-if="tableHeaderList.includes('bsBackAmt')"></el-table-column>
            <el-table-column min-width="100px" prop="yzdAmt" label="圆准达服务费" align="center" v-if="tableHeaderList.includes('yzdAmt')"></el-table-column>
            <el-table-column prop="senderName" label="寄件人姓名" align="center" v-if="tableHeaderList.includes('senderName')"></el-table-column>
            <el-table-column prop="senderAddress" label="寄件人地址" align="center" v-if="tableHeaderList.includes('senderAddress')"></el-table-column>
            <el-table-column prop="receiverName" label="收件人姓名" align="center" v-if="tableHeaderList.includes('receiverName')"></el-table-column>
            <el-table-column prop="receiverAddress" label="收件人地址" align="center" v-if="tableHeaderList.includes('receiverAddress')"></el-table-column>
            <el-table-column min-width="100px" prop="isReturn" label="是否更址/退回" align="center" v-if="tableHeaderList.includes('isReturn')"></el-table-column>            
          </el-table>
          <div class="y-mt-20">
            <el-pagination
              class="y-t-ac"
              @size-change="detailLimitChange"
              @current-change="detailPageChange"
              :current-page.sync="detailPageNo"
              :page-sizes="[10, 20, 50]"
              :page-size="detailLimit"
              layout="total, sizes, prev, pager, next"
              :total="detailTotal">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="申诉明细" :visible.sync="dialogTableVisible" :close-on-click-modal="false">
      <el-form :inline="true">
        <el-form-item label="运单号">
          <el-input placeholder="输入运单号查询" v-model="dialogWaybillNo" size="mini" class="y-w-180"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="dialogPageChange(1)">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="dialogData" class="y-mb-20" v-loading="dialogLoading">
        <el-table-column property="waybillNo" label="运单号码" align="center" width="130"></el-table-column>
        <el-table-column property="weight" label="计费重量" align="center" width="100"></el-table-column>
        <el-table-column property="province" label="计费省份" align="center" width="100"></el-table-column>
        <el-table-column property="differenceName" label="差异类型" align="center"></el-table-column>
        <el-table-column property="differenceContent" label="差异内容" align="center"></el-table-column>
        <el-table-column property="complaintStatusName" label="申诉处理状态" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.complaintStatusName=='已驳回'" class="y-fc-F32F52">{{scope.row.complaintStatusName}}</span>
            <span v-else>{{scope.row.complaintStatusName}}</span>
          </template>
        </el-table-column>
        <el-table-column property="rejectedReason" label="驳回原因" align="center">
          <template slot-scope="scope">
            {{scope.row.rejectedReason}}
            <template v-if="scope.row.rejectedPics && scope.row.rejectedPics.length">
              <template v-for="(item,index) in scope.row.rejectedPics">
                <span class="y-ml-10 y-fc-4C84FF y-c-p" :key="item" @click="toShowImg(item)">图片{{index+1}}</span>
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="y-t-ac"
        @size-change="dialogLimitChange"
        @current-change="dialogPageChange"
        :current-page.sync="dialogPageNo"
        :page-sizes="[10, 20, 50]"
        :page-size="dialogLimit"
        layout="total, sizes, prev, pager, next"
        :total="dialogTotal">
      </el-pagination>
      <el-dialog :visible.sync="dialogVisible" title="图片" @close='closeImg' class="imgDialog" append-to-body>
        <div>
          <img width="80%" style="display:block; margin:0 auto" :src="dialogImageUrl" alt="">
        </div>
      </el-dialog>
    </el-dialog>
    <!-- 自动对账 -->
    <import-bill :show.sync="autoVerifyBillDialog" :info="autoVerifyBillInfo" @handleImpSts="handleImpSts"></import-bill>
      <!-- 自定义列 -->
    <tableConfiguration
      :value="tableConfigurationDialog"
      :data="tableConfigList"
      :activeName="activeName"
      v-if="tableConfigurationDialog"
      @close="closeTableConfigurationDialog"
    ref="mergeOrderDetail"
    ></tableConfiguration>
  </div>
</template>

<script>
import { getCurGroupAllKcodeApi } from '../../../api/universal';
import { getSummaryListApi, getBillNoByColumnsApi, getBillDetailListApi, getBillDetailSumApi, exportSummaryDataApi, exportDetailDataApi, confirmOrdinaryBillApi, getAppealDetailListApi } from '../../../api/finance/billStatistics/ordinaryBill';
import { queryUserColumnSettingApi } from '../../../api/columnSetting';
import { downloadFile, dateFormat, compareObj } from '@/utils/util.js';
import ImportBill from './components/importBill.vue';// 自动对账弹层
import tableConfiguration from './components/tableConfiguration'; // 自定义列
import CheckDown from './components/checkDown.vue';// 列表下拉筛选项组件
import district from '@/mixins/district';// 省市区接口

export default {
  name: 'finance',
  components: {ImportBill,tableConfiguration,CheckDown},
  mixins: [district],
  computed: {
    pickerOptions() {
      let self = this;
      return{
        onPick: ({ maxDate, minDate }) => {
          // 把选择的第一个日期赋值给一个变量。
          self.choiceDate = minDate.getTime();
          // 如何你选择了两个日期了，就把那个变量置空
          if (maxDate) self.choiceDate = "";
        },
        disabledDate (time ) {
          // 如何选择了一个日期
          if (self.choiceDate) {
            // 31天的时间戳
            const one = 30 * 24 * 3600 * 1000;
            // 当前日期 - one = 31天之前
            const minTime = self.choiceDate - one;
            // 当前日期 + one = 31天之后
            const maxTime = self.choiceDate + one;
            return (
              time.getTime() < minTime ||
              time.getTime() > maxTime
              // 限制不能选择明天及以后
              || time.getTime() > Date.now()
            );
          } else {
            // 如果没有选择日期，就要限制不能选择明天及以后
            return time.getTime()  > Date.now();
          }
        }
      }
    },
    userMess() {
      return this.$store.state.user;
    }
  },
  data() {
    return {
      showTable: false,//tableConfigHeadList更新时刷新table
      activeName: 'summary',
      loading: true,
      form: {
        customerCode: '',
        billingStatus: '0',
        createTime: []
      },
      // searchCustomerCode: '',
      // searchCreateTime: [],
      kCodeOpts: [],// 客户编码下拉列表
      summaryData: [],// 汇总列表数据
      pageNo: 1,
      limit: 10,
      total: 0,
      sortType: 'DESC', //（升序ASC;降序DESC）
      sortColum: 'createTime',
      multipleSelection:[],// 汇总多选项
      detailData: [],// 明细列表数据
      detailDataByTotal:{},// 明细列表合计行数据
      detailTotal: 0,
      detailLimit: 10,
      detailPageNo: 1,
      sortTypeByDetail: 'DESC', //（升序ASC;降序DESC）
      sortColumByDetail: 'createTime',
      curRow: null, // 当前详情的行数据
      inputWaybillNo: '', // 明细查询运单号
      searchedWaybillNo: '', // 点击查询后的运单号
      dialogData: [],// 申诉明细列表数据
      dialogInfo: {},// 申诉明细信息
      dialogLoading: false,
      dialogTableVisible: false,
      dialogWaybillNo:'',
      dialogTotal: 0,
      dialogLimit: 10,
      dialogPageNo: 1,
      autoVerifyBillDialog: false,// 自动对账
      autoVerifyBillInfo:{},
      dialogVisible:false,// 图片dialog
      dialogImageUrl:'',
      allbillList:[],// 账单编号汇总下拉
      billingNoLst:[],// 已选择账单列表
      provinceList:[],// 省区接口返回原始列表
      allProvinceList:[],// 省区汇总下拉
      provinceLst:[],// 已选择省区列表
      tableConfigurationDialog: false, // 自定义列
      tableConfigList: [],
      tableConfigHeadList: [],
      // 汇总列表列配置
      tableConfigList1: [
        {
          "id": 1,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "账单编号",
          "enName": "billingNo",
          "isDefaultSelected": 1,
          "isCancelSelected": 0,
          "isSelected": 1,
          "sort": 1
        },
        {
          "id": 2,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "账单开始时间",
          "enName": "startTime",
          "isDefaultSelected": 1,
          "isCancelSelected": 0,
          "isSelected": 1,
          "sort": 2
        },
        {
          "id": 3,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "账单结束时间",
          "enName": "endTime",
          "isDefaultSelected": 1,
          "isCancelSelected": 0,
          "isSelected": 1,
          "sort": 3
        },
        {
          "id": 4,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "账单生成时间",
          "enName": "createTime",
          "isDefaultSelected": 1,
          "isCancelSelected": 0,
          "isSelected": 1,
          "sort": 4
        },
        {
          "id": 5,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "对账状态",
          "enName": "billingStatusName",
          "isDefaultSelected": 1,
          "isCancelSelected": 0,
          "isSelected": 1,
          "sort": 5
        },
        {
          "id": 6,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "客户编码",
          "enName": "code",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 6
        },
        {
          "id": 7,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "客户名称",
          "enName": "name",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 7
        },
        {
          "id": 8,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "总票数",
          "enName": "totalPcs",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 8
        },
        {
          "id": 9,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "总重量",
          "enName": "totalWeight",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 9
        },
        {
          "id": 10,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "应收金额",
          "enName": "receivableAmt",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 10
        },
        {
          "id": 11,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "总金额",
          "enName": "totalAmount",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 11
        },
        {
          "id": 12,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "理赔款",
          "enName": "compensateAmt",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 12
        },
        {
          "id": 13,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "运费",
          "enName": "totalTransFee",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 13
        },
        {
          "id": 224,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "加收费",
          "enName": "addAmount",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 14
        },
        {
          "id": 14,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "操作费",
          "enName": "totalOptFee",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 15
        },
        {
          "id": 15,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "扶持派送费",
          "enName": "totalAidDeliveryFee",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 16
        },
        {
          "id": 16,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "附加费",
          "enName": "totalExtraFee",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 17
        },
        {
          "id": 17,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "计重费",
          "enName": "totalOptWeightFee",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 18
        },
        {
          "id": 18,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "超重派送费",
          "enName": "totalOverweightFee",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 19
        },
        {
          "id": 19,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "附加费出港",
          "enName": "yqAddAmount",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 20
        },
        {
          "id": 20,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "超区件",
          "enName": "ultFeeAmt",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 21
        },
        {
          "id": 21,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "退回逆向费用",
          "enName": "backReverseAmt",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 22
        },
        {
          "id": 22,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "退回件服务费",
          "enName": "bsBackAmt",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 23
        },
        {
          "id": 23,
          "tabCode": 101,
          "tabName": "普通账单汇总列",
          "cnName": "圆准达服务费",
          "enName": "yzdAmt",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 24
        },
      ],
      // 明细列表列配置
      tableConfigList2: [
        {
          "id": 24,
          "tabCode": 102,
          "tabName": "普通账单明细列",
          "cnName": "运单号码",
          "enName": "waybillNo",
          "isDefaultSelected": 1,
          "isCancelSelected": 0,
          "isSelected": 1,
          "sort": 1
        },
        {
          "id": 25,
          "tabCode": 102,
          "tabName": "普通账单明细列",
          "cnName": "计费结算对象名称",
          "enName": "originSettName",
          "isDefaultSelected": 1,
          "isCancelSelected": 0,
          "isSelected": 1,
          "sort": 2
        },
        {
          "id": 26,
          "tabCode": 102,
          "tabName": "普通账单明细列",
          "cnName": "扫描时间",
          "enName": "createTime",
          "isDefaultSelected": 1,
          "isCancelSelected": 0,
          "isSelected": 1,
          "sort": 3
        },
        {
          "id": 27,
          "tabCode": 102,
          "tabName": "普通账单明细列",
          "cnName": "计费重量",
          "enName": "weight",
          "isDefaultSelected": 1,
          "isCancelSelected": 0,
          "isSelected": 1,
          "sort": 4
        },
        {
          "id": 28,
          "tabCode": 102,
          "tabName": "普通账单明细列",
          "cnName": "计费省份",
          "enName": "provinceName",
          "isDefaultSelected": 1,
          "isCancelSelected": 0,
          "isSelected": 1,
          "sort": 5
        },
        {
          "id": 29,
          "tabCode": 102,
          "tabName": "普通账单明细列",
          "cnName": "计费目的地",
          "enName": "DesOrgName",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 6
        },
        {
          "id": 30,
          "tabCode": 102,
          "tabName": "普通账单明细列",
          "cnName": "应收金额",
          "enName": "receivableAmt",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 7
        },
        {
          "id": 31,
          "tabCode": 102,
          "tabName": "普通账单明细列",
          "cnName": "总金额",
          "enName": "billAmount",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 8
        },
        {
          "id": 32,
          "tabCode": 102,
          "tabName": "普通账单明细列",
          "cnName": "理赔款",
          "enName": "compensateAmt",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 9
        },
        {
          "id": 33,
          "tabCode": 102,
          "tabName": "普通账单明细列",
          "cnName": "物料结算名称",
          "enName": "matName",
          "isDefaultSelected": 1,
          "isCancelSelected": 1,
          "isSelected": 1,
          "sort": 10
        },
      ],
      tableHeaderList:[],// 明细列表网点管家动态列
      // 汇总列表排序项
      tableSortList:[
        'startTime',// 账单开始时间
        'endTime',// 账单结束时间
        'createTime',// 账单生成时间
        'totalPcs',// 总票数
        'totalWeight',// 总重量
        'receivableAmt',// 应收金额
        'totalAmount',// 总金额
        'compensateAmt',// 理赔款
        'totalTransFee',// 运费
        'addAmount',// 加收费
        'totalOptFee',// 操作费
        'totalAidDeliveryFee',// 扶持派送费
        'totalExtraFee',// 附加费
        'totalOptWeightFee',// 计重费
        'totalOverweightFee',// 超重派送费
        'yqAddAmount',// 附加费出港
        'ultFeeAmt',// 超区件
        'backReverseAmt',// 退回逆向费用
        'bsBackAmt',// 退回件服务费
        'yzdAmt',// 圆准达服务费
      ],
      // 汇总列表排序项
      tableSortListByDetail:[
        'createTime',// 扫描时间
        'weight',// 计费重量
        'receivableAmt',// 应收金额
        'billAmount',// 总金额
        'compensateAmt',// 理赔款
      ],
    };
  },
  created() {
    let today = new Date();
    this.$set(this.form, 'createTime', [today.getFullYear() + '-' + (today.getMonth() + 1) + '-1', today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()]);
    getCurGroupAllKcodeApi({}).then(res => {
      if (res.status === 0) {
        this.kCodeOpts = res.data || [];
      } else {
        this.kCodeOpts = [];
      }
    }).catch(() => {
      this.kCodeOpts = [];
    }).finally(()=>{
      this.form.customerCode = (this.$route.query && this.$route.query.kcode) ? this.$route.query.kcode : ((this.kCodeOpts && this.kCodeOpts.length) ? this.kCodeOpts[0].code : '');
      this.getList();
      this.queryUserColumnConfig();
    });
  },
  mounted(){
    // 获取省区下拉列表
    this.getDistrict('086', this.provinceList)
  },
  filters: {
    dateFilter(value) {
      if (!value) return ''
      return dateFormat(new Date(value), 'yyyy-MM-dd hh:mm:ss')
    }
  },
  watch: {
    activeName(val,oldVal){
      this.detailData = [];
      this.detailTotal = 0;
      this.detailPageNo = 1;
      this.summaryData = [];
      this.pageNo = 1;
      this.total = 0;
      this.sortType = 'DESC'; //（升序ASC;降序DESC）
      this.sortColum = 'createTime';
      this.sortTypeByDetail = 'DESC'; //（升序ASC;降序DESC）
      this.sortColumByDetail = 'createTime';
    },
    // 省区汇总下拉格式化
    provinceList(val,oldVal){
      if(val && val.length){
        let list = JSON.parse(JSON.stringify(val));
        list.forEach(r => {
          r.id = r.code;
          r.label = r.name;
        });
        this.allProvinceList = list;
      }else{
        this.allProvinceList = [];
      }
    }
  },
  methods: {
    // 汇总表格排序
    sortChange(column) {
      // （升序ASC;降序DESC）
      if (column.order === 'ascending') {// 升序
        this.sortType = 'ASC';
      } else if (column.order === 'descending') {// 降序
        this.sortType = 'DESC';
      }
      this.sortColum = column.prop;
      this.billingNoLst = [];
      this.getList();
    },
    // 明细表格排序
    sortChangeByDetail(column) {
      // （升序ASC;降序DESC）
      if (column.order === 'ascending') {// 升序
        this.sortTypeByDetail = 'ASC';
      } else if (column.order === 'descending') {// 降序
        this.sortTypeByDetail = 'DESC';
      }
      this.sortColumByDetail = column.prop;
      this.provinceLst = [];
      this.getList();
    },
    // 汇总多选
    handleSelectionChange(list) {
      this.multipleSelection = list;
    },
    // 打开自定义列dialog
    tableConfig() {
      this.tableConfigurationDialog = true;
      this.queryUserColumnConfig();
    },
    // 关闭自定义列dialog
    closeTableConfigurationDialog() {
      this.tableConfigurationDialog = false;
      this.queryUserColumnConfig();
      // this.tbody = [...this.tbody];
    },
    // 查询自定义列
    queryUserColumnConfig() {
      let params = {
        tabCode: ( this.activeName == 'summary' ) ? 101 : 102, // 汇总101，明细102
        userId: this.userMess.loginId
      };
      let loadingMask = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      queryUserColumnSettingApi(params).then(res => {
        // loadingMask.close();
        if (res.message === 'ok' && res.data && res.data.length > 0) {
          let list = res.data || [];
          if (list.length) {
            list = list.sort(compareObj('sort', 'ASC'));
          }
          this.tableConfigList = list;
        } else {
          if (this.activeName === 'summary') {
            this.tableConfigList = this.tableConfigList1;
          } else {
            this.tableConfigList = this.tableConfigList2;
          }
        }
      }).catch(() => {
        // loadingMask.close();
        if (this.activeName === 'summary') {
          this.tableConfigList = this.tableConfigList1;
        } else {
          this.tableConfigList = this.tableConfigList2;
        }
      }).finally(() => {
        // loadingMask.close();
        this.showTable = false;
        let id = 0;
        let selectList = this.tableConfigList.map((item,index) => {
          if (item.isSelected && item.isSelected === 1) {
            if(item.enName==='billingStatusName'){
              id = index;
            }
            return item;
          }
        });
        loadingMask.close();
        if (this.activeName === 'summary') {
          selectList.splice(id+1 ,0,{tabCode: 101,cnName: "申诉明细",enName:'shensuDetail'});
          this.tableConfigHeadList = selectList.filter(Boolean);
        }else{
          this.tableConfigHeadList = selectList.filter(Boolean);
        }
        this.tableConfigHeadList = [...this.tableConfigHeadList]
        this.$nextTick(()=>{
          // 表头更新时刷新table，防止table数据错乱
          this.summaryData = [...this.summaryData];
          this.detailData = [...this.detailData];
          this.showTable = true;
          console.log(111111111111111111)
        })
      });
    },
    toShowImg(src){
      this.dialogVisible = true;
      this.dialogImageUrl = src;
    },
    closeImg() {
      this.dialogVisible = false;
      this.dialogImageUrl = '';
    },
    // tab点击切换汇总、明细
    handleTabClick() {
      if(this.activeName === 'summary') {
        this.curRow = null; // 切换到汇总时 明细信息置空，初始化调用handleSearch()列表接口、下拉接口、列配置接口
        this.detailData = [];
        this.detailTotal = 0;
        this.detailLimit = 10;
        this.inputWaybillNo = '';
        this.searchedWaybillNo = '';
        this.handleSearch();
      }else{
        // 切换到明细时 初始化调用列配置
        this.queryUserColumnConfig();
      }
    },
    // 汇总初始化查询
    handleSearch() {
      this.activeName = 'summary';
      this.curRow = null;
      this.pageNo = 1;
      this.billingNoLst = [];
      this.provinceLst = [];
      this.sortType = 'DESC'; //（升序ASC;降序DESC）
      this.sortColum = 'createTime';
      this.sortTypeByDetail = 'DESC'; //（升序ASC;降序DESC）
      this.sortColumByDetail = 'createTime';
      this.getList('config'); 
    },
    // 明细查询运单号
    handleSearchWay() {
      this.detailPageNo = 1;
      this.provinceLst = [];
      // 明细查询运单号
      if(this.curRow) {
        this.getList();
      }
    },
    // 明细每页条数改变
    detailLimitChange(val) {
      this.detailLimit = val;
      this.detailPageNo = 1;
      this.getList();
    },
    // 汇总每页条数改变
    limitChange(val) {
      this.limit = val;
      this.pageNo = 1;
      this.getList();
    },
    // 明细页码改变
    detailPageChange(val) {
      this.detailPageNo = val;
      this.getList();
    },
    // 汇总页码改变
    pageChange(val) {
      this.pageNo = val;
      this.getList();
    },
    // 账单汇总导出
    handleExport() {
      let query = {
        critertion: {
          createStartTime: "",
          createEndTime: "",
          customerCode: "",
          orderByParameter: this.sortColum,
          orderByType: this.sortType,
          billingStatus: this.form.billingStatus,
          billingNoLst: this.billingNoLst,
        },
        total: this.total,
        channel: "khgj",
        pageIndex: this.pageNo,
        pageSize: this.limit
      };
      if (this.form.customerCode !== '') {
        if (this.form.customerCode === '全部') {
          query.critertion.customerCode = '';
        } else {
          query.critertion.customerCode = this.form.customerCode;
        }
      }
      if (this.form.createTime && this.form.createTime.length > 0) {
        query.critertion.createStartTime = this.form.createTime[0] + ' 00:00:00';
        query.critertion.createEndTime = this.form.createTime[1] + ' 23:59:59';
      }
      // this.searchCreateTime = JSON.parse(JSON.stringify(this.form.createTime));
      // this.searchCustomerCode = query.critertion.customerCode;
      let loadingMask = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      exportSummaryDataApi(query).then(res => {
        loadingMask.close();
        let blob = new Blob([res]);
        let fileName = '客户管家账单汇总导出.xlsx';
        downloadFile(blob, fileName);
      }).catch(()=>{
        loadingMask.close();
      })
    },
    //  明细列表导出
    exportDetailData() {
      // 明细
      let query = {
        critertion:{
          billingNo: this.curRow.billingNo,
          customerCode: this.curRow.code,
          orgCodes: [this.curRow.createOrgCode],
          waybillNos: [],
          orderByParameter: this.sortColumByDetail,
          orderByType: this.sortTypeByDetail,
          billingStatus: this.form.billingStatus,
          provinceLst: this.provinceLst,
        },
        channel: "khgj",
        pageIndex: this.detailPageNo,
        pageSize: this.detailLimit,
        total: this.detailTotal,
      };
      query.critertion.waybillNos = this.searchedWaybillNo ? [this.searchedWaybillNo] : [];
      let loadingMask = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      exportDetailDataApi(query).then(res => {
        loadingMask.close();
        let blob = new Blob([res]);
        let fileName = '客户管家账单明细导出.xlsx';
        downloadFile(blob, fileName);
      }).catch(()=>{
        loadingMask.close();
      })
    },
    // 省区下拉查询
    checkedProvince(obj){
      this.provinceLst = obj.isCheckIdList;
      this.pageChange(1);
    },
    // 账单下拉查询
    checkedOrder(obj){
      this.billingNoLst = obj.isCheckIdList;
      this.pageChange(1);
    },
    // 明细数据汇总
    getBillDetailSum(){
        // 明细
        let query = {
          critertion:{
            billingNo: this.curRow.billingNo,
            customerCode: this.curRow.code,
            orgCodes: [this.curRow.createOrgCode],
            waybillNos: [this.inputWaybillNo],
            orderByParameter: this.sortColumByDetail,
            orderByType: this.sortTypeByDetail,
            billingStatus: this.form.billingStatus,
            provinceLst: this.provinceLst,
          },
          channel: "khgj",
          pageIndex: this.detailPageNo,
          pageSize: this.detailLimit,
        };
        if(this.inputWaybillNo){
          query.critertion.billingNo = '';
        }
        this.loading = true;
        getBillDetailSumApi(query).then(res => {
          this.loading = false;
          this.detailDataByTotal = {};
          if(res.status==200 && res.data && res.data.data && res.data.data.list){
            this.detailDataByTotal = res.data.data.list[0] || {}
          }else{
            this.detailDataByTotal = {};
          }
        }).catch(() => {
          this.loading = false;
          this.detailDataByTotal = {};
        })
    },
    // 明细数据合计行
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }else{
          sums[index] = (this.detailDataByTotal && (this.detailDataByTotal[column.property] || this.detailDataByTotal[column.property] === 0)) ? this.detailDataByTotal[column.property] : '';
        }
      });
      return sums;
    },
    //  获取账单下拉列表
    getBillNo(){
      let query = {
          critertion: {
            createStartTime: "",
            createEndTime: "",
            customerCode: "",
            orderByParameter: this.sortColum,
            orderByType: this.sortType,
            billingStatus: this.form.billingStatus,
          },
          channel: "khgj",
          pageIndex: this.pageNo,
          pageSize: this.limit
        };
        if (this.form.customerCode !== '') {
          if (this.form.customerCode === '全部') {
            query.critertion.customerCode = '';
          } else {
            query.critertion.customerCode = this.form.customerCode;
          }
        }
        if (this.form.createTime && this.form.createTime.length > 0) {
          query.critertion.createStartTime = this.form.createTime[0] + ' 00:00:00';
          query.critertion.createEndTime = this.form.createTime[1] + ' 23:59:59';
        }
        // this.searchCreateTime = JSON.parse(JSON.stringify(this.form.createTime));
        // this.searchCustomerCode = query.critertion.customerCode;
        this.loading = true;
        getBillNoByColumnsApi(query).then(res => {
          this.loading = false;
          this.allbillList = [];
          if(res.status==200 && res.data && res.data.data && res.data.data.items){
            let arr = res.data.data.items || [];
            let obj = {};
            // 将数组转化为对象
            for (let key in arr) {
                obj[key] = arr[key];
            };
            let newObj = Object.keys(obj).map(val => ({id: obj[val],label: obj[val]}));
            this.allbillList = [...newObj];
            this.allbillList = this.allbillList
          }else{
            this.allbillList = [];
          }
        }).catch(() => {
          this.loading = false;
          this.allbillList = [];
        })
    },
    getList(code) {
      if(this.activeName === 'summary') {
        this.getBillNo();
        let query = {
          critertion: {
            createStartTime: "",
            createEndTime: "",
            customerCode: "",
            orderByParameter: this.sortColum,
            orderByType: this.sortType,
            billingStatus: this.form.billingStatus,
            billingNoLst: this.billingNoLst,
          },
          channel: "khgj",
          pageIndex: this.pageNo,
          pageSize: this.limit
        };
        if (this.form.customerCode !== '') {
          if (this.form.customerCode === '全部') {
            query.critertion.customerCode = '';
          } else {
            query.critertion.customerCode = this.form.customerCode;
          }
        }
        if (this.form.createTime && this.form.createTime.length > 0) {
          query.critertion.createStartTime = this.form.createTime[0] + ' 00:00:00';
          query.critertion.createEndTime = this.form.createTime[1] + ' 23:59:59';
        }
        // this.searchCreateTime = JSON.parse(JSON.stringify(this.form.createTime));
        // this.searchCustomerCode = query.critertion.customerCode;
        // 汇总
        this.loading = true;
        getSummaryListApi(query).then(res => {
          this.loading = false;
          if(res.status==200 && res.data){
            this.summaryData = res.data.list || [];
            this.total = res.data.total || 0;
          }else{
            if(res.status==-1 && res.error){
              this.$message.error(res.error);
            }
            this.summaryData = [];
            this.total = 0;
            this.pageNo = 1;
          }
        }).catch(() => {
          this.summaryData = [];
          this.total = 0;
          this.pageNo = 1;
          this.loading = false;
        }).finally(()=>{
          this.$nextTick(()=>{
            if(code=='config'){
              // 列表列配置
              this.queryUserColumnConfig();
            }
          })
        })
      }
      if(this.activeName === 'detail' && this.curRow) {
        this.getBillDetailSum();
        this.searchedWaybillNo = this.inputWaybillNo;
        // 明细
        let query = {
          critertion:{
            billingNo: this.curRow.billingNo,
            customerCode: this.curRow.code,
            orgCodes: [this.curRow.createOrgCode],
            waybillNos: [this.inputWaybillNo],
            orderByParameter: this.sortColumByDetail,
            orderByType: this.sortTypeByDetail,
            billingStatus: this.form.billingStatus,
            provinceLst: this.provinceLst,
          },
          channel: "khgj",
          pageIndex: this.detailPageNo,
          pageSize: this.detailLimit,
        };
        if(this.inputWaybillNo){
          query.critertion.billingNo = '';
        }
        this.loading = true;
        getBillDetailListApi(query).then(res => {
          this.loading = false;
          if(res.status==200 && res.data){
            this.detailData = res.data.list || [];
            this.detailTotal = res.data.total || 0;
          }else{
            this.detailData = [];
            this.detailTotal = 0;
            this.detailPageNo = 1;
          }
        }).catch(() => {
          this.detailData = [];
          this.detailTotal = 0;
          this.detailPageNo = 1;
          this.loading = false;
        }).finally(()=>{
          this.tableHeaderList = [];
          if(this.detailData && this.detailData.length){
            this.tableHeaderList = Object.keys(this.detailData[0])
          }
          this.$nextTick(()=>{
            if(code=='config'){
              // 列表列配置
              this.queryUserColumnConfig();
            }
          })
        })
      }
    },
    handleClick(row) {
      this.curRow = row;
      this.activeName = 'detail';
      this.inputWaybillNo = '';//清除明细查询运单号
      this.searchedWaybillNo = '';//清除点击查询后的运单号
      this.getList('config');
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form.customerCode = (this.kCodeOpts && this.kCodeOpts.length) ? this.kCodeOpts[0].code : '';
      this.$nextTick(()=>{
        this.handleSearch();
      })
    },
    // 确认账单
    confirmBill(row) {
      this.$confirm('确认即您对账单没有异议，确认后无法撤销，要确认账单吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let query = {
          "billingNo": row.billingNo,
          "billingStatus": row.billingStatus,
          "channel": "khgj",
          "createOrgCode": row.createOrgCode,
          "customerCode": row.code
        }
        const loading = this.$loading({
          lock: true,
          text: '请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        })
        confirmOrdinaryBillApi(query).then(res => {
          loading.close();
          if(res.status==200){
            this.$message.success('确认成功');
            this.pageChange(1);
          }else{
            this.$message.error(res.error || '确认失败');
          }
        }).catch(() => {
          loading.close();
          this.$message.error('确认失败');
        })
      }).catch(() => {      
      });
    },
    // 自动对账
    autoVerifyBill(code){
      if(code=='summary'){
        if (!(this.multipleSelection.length && this.multipleSelection.length == 1)) {
          this.$message.error('请勾选一项账单！');
          return false;
        }
        // 明细
        let query = {
          critertion:{
            billingNo: this.multipleSelection[0].billingNo,
            customerCode: this.multipleSelection[0].code,
            orgCodes: [this.multipleSelection[0].createOrgCode],
            waybillNos: [],
            orderByParameter: this.sortColumByDetail,
            orderByType: this.sortTypeByDetail,
          },
          channel: "khgj",
          pageIndex: this.detailPageNo,
          pageSize: this.detailLimit,
        };
        const loading = this.$loading({
          lock: true,
          text: '请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        })
        getBillDetailListApi(query).then(res => {
          if(res.status==200 && res.data){
            this.detailTotal = res.data.total || 0;
          }else{
            this.detailTotal = 0;
          }
        }).catch(() => {
          this.detailTotal = 0;
        }).finally(()=>{
          loading.close();
          this.$nextTick(()=>{
            if(this.detailTotal && this.multipleSelection[0] && this.multipleSelection[0].billingStatus!='1'){
              this.autoVerifyBillDialog = true;
              this.autoVerifyBillInfo = this.multipleSelection[0];
              this.autoVerifyBillInfo.total = this.detailTotal;
            }else{
              this.$message.error('勾选的账单不支持自动对账，请重新选择！');
              return false;
            }
          })
        })
      }else{
        this.autoVerifyBillDialog = true;
        this.autoVerifyBillInfo = this.curRow
        this.autoVerifyBillInfo.total = this.detailTotal;
      }
    },
    handleImpSts(){

    },
    // 申诉明细
    complaintDetails(row){
      this.dialogTableVisible = true;
      this.dialogInfo = row;
      this.dialogWaybillNo = '';
      this.dialogSearch();
    },
    // 申诉明细查询
    dialogSearch(){
      let query = {
        billingNo: this.dialogInfo.billingNo,
        customerCode: this.dialogInfo.code,
        createOrgCode: this.dialogInfo.createOrgCode,
        wayBillNos: [],
        channel: "khgj",
        pageIndex: this.dialogPageNo,
        pageSize: this.dialogLimit,
      };
      if(this.dialogWaybillNo){
        query.wayBillNos = [this.dialogWaybillNo];
      }
      // this.dialogData=[
      //   {
      //     "rejectedPics": "[\"http://10.130.9.50:30011/v1/file/getImage?filePath=group3/M00/00/97/CoIk62ObyX-IBxwQAADXDPfUsGMAAAAngKPKhEAANc8217.jpg\"]",
      //     "complaintStatusName": "待处理",
      //     "customerCode": "K21002160",
      //     "weight": 8,
      //     "differenceName": "未找到单号",
      //     "provinceReport": "",
      //     "differenceType": "0",
      //     "complaintStatus": "0",
      //     "province": "上海",
      //     "rejectedReason": "wsqwqw",
      //     "weightReport": "0.0",
      //     "billNo": "YFK2100011922120717422111",
      //     "waybillNo": "YT2600274134400"
      //   }
      // ];
      this.dialogLoading = true;
      getAppealDetailListApi(query).then(res => {
        this.dialogLoading = false;
        if(res.status==200 && res.data){
          this.dialogData = res.data.appealBillDetailRes || [];
          this.dialogTotal = res.data.total || 0;
        }else{
          this.dialogData = [];
          this.dialogTotal = 0;
          this.dialogPageNo = 1;
        }
      }).catch(() => {
        this.dialogData = [];
        this.dialogTotal = 0;
        this.dialogPageNo = 1;
        this.dialogLoading = false;
      })
    },
    dialogPageChange(val) {
      this.dialogPageNo = val;
      this.dialogSearch();
    },
    dialogLimitChange(val) {
      this.dialogLimit = val;
      this.dialogPageNo = 1;
      this.dialogSearch();
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .el-date-editor, .el-input--small {
    width: 250px;
  }
  .ordinaryBill {
    background-color: #fff;
    height: calc(100vh - 100px);
    overflow: auto;
  }
</style>
